import {all} from 'redux-saga/effects';
import commissionSchedulesSaga from 'Agent/Commissions/sagas/commissionSchedulesSaga';
import commissionsSaga from 'Agent/Commissions/sagas/commissionsSaga';
import a360CommissionsSaga from 'Agent/Commissions/sagas/a360CommissionsSaga';
import a360CommissionsReportSaga from './a360CommissionsReportSaga';

export default function*() {
  yield all([commissionSchedulesSaga(), commissionsSaga(), a360CommissionsSaga(), a360CommissionsReportSaga()]);
}
